import { render, staticRenderFns } from "./radiobox.vue?vue&type=template&id=5a74b1ba"
import script from "./radiobox.vue?vue&type=script&lang=js"
export * from "./radiobox.vue?vue&type=script&lang=js"
import style0 from "./radiobox.vue?vue&type=style&index=0&id=5a74b1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports